import React from 'react'
import SweetAlert from 'react-bootstrap-sweetalert'
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress'
import { TheoryModel } from "shared/models/theory.model"
import PaginatedProjects from '../../components/PaginatedProjects/PaginatedProjects'
import PropTypes from 'prop-types'
import { bindActionCreators, compose } from 'redux'
import {
	cloneTheory,
	createTheory,
	deployTheory,
	fetchTheoryPipeline,
	fetchTheoryProjects
} from "actions/theory.actions"
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core'
import eventUnitsStyle from '../../shared/assets/jss/material-dashboard-pro-react/views/eventUnitsStyle'
import { withIntl } from "@hlcr/ui/Intl"

const LoadingModal = ({ title, onConfirm }) => (
	<SweetAlert title={title} onConfirm={onConfirm} showConfirm={false}>
		<CircularProgress />
	</SweetAlert>
)

class List extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			alert: null
		}
	}

	showLoadingModal = title => {
		this.setState({
			alert: <LoadingModal title={title} onConfirm={() => this.hideAlert()} />
		})
	}

	hideAlert = () => {
		this.setState({
			alert: null
		})
	}

	handleNewTheory = () => {
		this.showLoadingModal(
			`Creating new ${this.props.intl.fm(`${this.props.languageKey}.name`)}`
		)
		this.props.createTheory(this.handleTheoryCreated)
	}

	handleCloneTheory = projectUuid => {
		this.showLoadingModal(
			`Cloning ${this.props.intl.fm(`${this.props.languageKey}.name`)}`
		)
		this.props.cloneTheory(projectUuid, this.handleTheoryCreated)
	}

	handleDeployTheory = (projectUuid, callback) => {
		this.showLoadingModal(
			`Deploying ${this.props.intl.fm(`${this.props.languageKey}.name`)}`
		)
		this.props.deployTheory(projectUuid, result => {
			this.handleTheoryCreated(result)
			if (callback) {
				callback(result)
			}
		})
	}

	handleTheoryCreated = (result: TheoryModel) => {
		if (result && result.uuid)
			this.props.history.push(`/${this.props.pathSegment}/${result.uuid}`)
		this.hideAlert()
	}

	handleFetchTheoryPipeline = (pipelineId, callback) => {
		this.props.fetchTheoryPipeline(pipelineId, result => {
			if (callback) {
				callback(result)
			}
		})
	}

	render() {
		const {
			paginatedTheoriesPending,
			paginatedTheories,
			triggerChange,
			fetchPage,
			languageKey,
			pathSegment,
			inputSearchValue,
			history,
			intl,
			classes,
			...other
		} = this.props

		return paginatedTheoriesPending ? (
			<LoadingModal
				title={intl.fm(`${this.props.languageKey}.loadingListText`)}
				onConfirm={() => this.hideAlert()}
			/>
		) : (
			<div>
				{this.state.alert}
				<PaginatedProjects
					triggerChange={triggerChange}
					inputSearchValue={inputSearchValue}
					fetchPage={fetchPage}
					createNewProject={this.handleNewTheory}
					cloneProject={this.handleCloneTheory}
					deployProject={this.handleDeployTheory}
					fetchPipeline={this.handleFetchTheoryPipeline}
					paginatedProjects={paginatedTheories}
					languageKey={languageKey}
					pathSegment={pathSegment}
					history={history}
					intl={intl}
					{...other}
				/>
			</div>
		)
	}
}

List.propTypes = {
	paginatedTheories: PropTypes.object,
	fetchTheoryProjects: PropTypes.func.isRequired,
	createTheory: PropTypes.func.isRequired,
	cloneTheory: PropTypes.func.isRequired,
	deployTheory: PropTypes.func.isRequired,
	fetchTheoryPipeline: PropTypes.func.isRequired
}

const mapStateToProps = (state, ownProps) => {
	return {
		paginatedTheoriesPending: state.api.resources.theories.pending
	}
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			createTheory,
			cloneTheory,
			deployTheory,
			fetchTheoryPipeline,
			fetchTheoryProjects
		},
		dispatch
	)

export default compose(
	connect(
		mapStateToProps,
		mapDispatchToProps
	),
	withStyles(eventUnitsStyle),
	withIntl
)(List)
